import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';

import { deskTopTextStyles, mobileTextStyles } from '../../styles/text-styles/';

const StyledBodyRegular = styled.div`
  font-size: ${(props) =>
    props.isMobile ? mobileTextStyles['body']['fontSize'] : deskTopTextStyles['body']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['body']['lineHeight']
      : deskTopTextStyles['body']['lineHeight']};
  color: ${(props) =>
    props.isMobile ? mobileTextStyles['body']['color'] : deskTopTextStyles['body']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['body']['fontWeight']
      : deskTopTextStyles['body']['fontWeight']};
`;

const StyledBodySmall = styled.div`
  font-size: ${deskTopTextStyles['bodySmall']['fontSize']};
  line-height: ${deskTopTextStyles['bodySmall']['lineHeight']};
  color: ${deskTopTextStyles['bodySmall']['color']};
  font-weight: ${deskTopTextStyles['body']['fontWeight']};
`;

const Body = ({ type, content, isMobile }) => {
  return (
    <React.Fragment>
      {type === 'regular' && <StyledBodyRegular isMobile={isMobile}> {content}</StyledBodyRegular>}
      {type === 'small' && <StyledBodySmall> {content}</StyledBodySmall>}
    </React.Fragment>
  );
};

Body.propTypes = {
  /**
   * How large should the body content be?
   */
  type: PropTypes.oneOf(['small', 'regular']),
  content: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};

Body.defaultProps = {
  type: 'regular',
  isMobile: false,
};

export { Body };
